import styled, { css } from 'styled-components';
import { getSchemaState } from '../../../foundation/theme/palette.utils';
import { getRadius, getSpace } from '../../../foundation/theme/space.utils';
// styled-components.
// -----------------------------------------------------------------------------
export const SpinnerBadgeRoot = styled.div `
  ${({ ...args }) => {
    const { background, border, foreground, active, foregroundAlt } = getSchemaState({
        ...args,
        schema: 'neutral',
        variant: 'white',
        state: 'default'
    });
    return css `
      /* Fixed rules */
      align-items: center;
      border-radius: ${getRadius('m')};
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;
      text-align: center;

      /* Colors */
      background-color: ${background};
      border: 2px solid ${border};
      color: ${foreground};

      /* Paddings */
      padding: ${getSpace('s')} ${getSpace('l')};

      /* Icon */
      .spinner-badge__icon--loading svg {
        color: ${active || foregroundAlt};
      }
    `;
}}
`;
//# sourceMappingURL=SpinnerBadge.styled.js.map